
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'lodash/isNumber';
import { s as setStyles } from './table-auto-height-mixin.js';
import PendoMultiselectValue from './pendo-multiselect-value.js';

var script = {
  name: 'PendoDataMeasureTrigger',
  components: {
    PendoIcon,
    PendoMultiselectValue
  },
  inject: ['multiselect'],
  inheritAttrs: false,
  props: {
    placeholderIcon: {
      type: Object,
      default: null
    }
  },
  watch: {
    'multiselect.isOpen': function (isOpen) {
      if (isOpen) {
        this.$el.focus();
      }
    },
    'multiselect.maxTriggerWidth': function () {
      setStyles(this.$refs.trigger, {
        maxWidth: this.multiselect.maxTriggerWidth
      });
    }
  },

  mounted() {
    setStyles(this.$refs.trigger, {
      minWidth: this.multiselect.isFullWidth ? '100%' : 0,
      maxWidth: this.multiselect.maxTriggerWidth
    });
  }

};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    ref: "trigger",
    staticClass: "pendo-multiselect__trigger",
    class: ["pendo-multiselect__trigger--mini", "pendo-multiselect__trigger--data-measure", {
      'is-active': _vm.multiselect.isFocused || _vm.multiselect.isOpen,
      'is-open': _vm.multiselect.isOpen,
      'is-disabled': _vm.multiselect.disabled
    }],
    attrs: {
      "slot": "trigger",
      "type": "button",
      "role": "button",
      "aria-haspopup": "",
      "aria-label": _vm.multiselect.isOpen ? 'close menu' : 'open menu',
      "aria-expanded": _vm.multiselect.isOpen ? true : undefined,
      "aria-disabled": String(_vm.multiselect.disabled)
    },
    on: {
      "focus": _vm.multiselect.handleFocus,
      "blur": _vm.multiselect.handleBlur,
      "click": _vm.multiselect.handleTriggerClick,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.multiselect.deactivate($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }

        $event.preventDefault();

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        $event.stopPropagation();
        return _vm.multiselect.handleKeydown('space', $event);
      }],
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }

        return _vm.multiselect.handleKeydown('tab');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }

        $event.preventDefault();

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.multiselect.handleKeydown('up');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.multiselect.handleKeydown('enter', $event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }

        $event.preventDefault();

        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.multiselect.handleKeydown('down');
      }]
    },
    slot: "trigger"
  }, [_c('pendo-multiselect-value', _vm._b({
    class: {
      'is-disabled': _vm.multiselect.disabled
    },
    scopedSlots: _vm._u([{
      key: "selectedLabel",
      fn: function (ref) {
        var selectedLabel = ref.selectedLabel;
        var option = ref.option;
        return [option.icon ? _c('pendo-icon', _vm._b({
          attrs: {
            "size": "12",
            "stroke-width": 2.5
          }
        }, 'pendo-icon', option.icon, false)) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "pendo-multiselect-selected__label"
        }, [_vm._v("\n                " + _vm._s(selectedLabel) + "\n            ")])];
      }
    }])
  }, 'pendo-multiselect-value', {
    getOptionLabel: _vm.multiselect.getOptionLabel,
    isPlaceholderVisible: _vm.multiselect.isPlaceholderVisible,
    isSelectedLabelVisible: _vm.multiselect.isSelectedLabelVisible,
    placeholder: _vm.multiselect.placeholder,
    selectedLabel: _vm.multiselect.selectedLabel,
    selectedValue: _vm.multiselect.selectedValue
  }, false)), _vm._v(" "), _c('div', {
    staticClass: "pendo-multiselect__suffix"
  }, [!_vm.multiselect.loading ? _c('pendo-icon', {
    staticClass: "pendo-multiselect__caret",
    class: {
      'is-active': _vm.multiselect.isOpen
    },
    attrs: {
      "type": "chevron-down",
      "size": "14",
      "stroke-width": 2.5
    }
  }) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-data-measure-trigger.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoDataMeasureTrigger = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoDataMeasureTrigger;
